import { render, staticRenderFns } from "./OtherIncomeResult.vue?vue&type=template&id=48821e66&scoped=true&"
import script from "./OtherIncomeResult.vue?vue&type=script&lang=js&"
export * from "./OtherIncomeResult.vue?vue&type=script&lang=js&"
import style0 from "./OtherIncomeResult.vue?vue&type=style&index=0&id=48821e66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48821e66",
  null
  
)

export default component.exports